import React, { useContext, useState } from "react";
import { Button, Input, Popover, QRCode, Table, Tooltip } from "antd";
import { QrcodeOutlined, ScheduleOutlined } from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import LOGO from "./../../../../assets/tinyimg/logo.webp";
import {
  CustomerOrderInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import MerchantEmployeeCheckoutPayLater from "./MerchantEmployeeCheckoutPayLater";

const MerchantEmployeeOrderPayLater = () => {
  const [search, setSearch] = useState("");
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { merchantPayLaterList, rerunPayLater } = useContext(CustomerOrderInfo);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      // title: dineTypeList && allowDineSetup ? "Location" : "Table Number",
      title: "Location",
      dataIndex: "table_no",
      render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
    },
    {
      title: "Status",
      dataIndex: "service_category",
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            color:
              text === "dine"
                ? "green"
                : text === "pickup"
                ? "#aeaeae"
                : text === "delivery"
                ? "#b804c2"
                : "blue",
            fontWeight: "bold",
          }}
        >
          {text === "dine"
            ? "DINE"
            : text === "pickup"
            ? "PICK UP"
            : text === "delivery"
            ? "DELIVERY"
            : "TAKE OUT"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 100,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 100 }}>
          <Tooltip title="Order QR" placement="bottom">
            <Popover
              overlayInnerStyle={{
                padding: 0,
              }}
              content={
                <QRCode
                  value={`${import.meta.env.VITE_API_SITE_URL}${
                    userData.data.usersmerchantemployee.merchant_user_id
                  }/${userData.data.usersmerchantemployee.merchant_uid}/${
                    text.transaction_id
                  }`}
                  bordered={false}
                  style={{
                    marginBottom: 16,
                  }}
                  icon={LOGO}
                  errorLevel="Q"
                />
              }
            >
              <Button
                type="dashed"
                shape="circle"
                //   onClick={() => {
                //     setSelectedData(text);
                //     // setOpenExtendDrawer(true);
                //   }}
                icon={<QrcodeOutlined />}
                style={{ marginRight: 5 }}
                size="small"
              />
            </Popover>
          </Tooltip>

          <Tooltip title="Checkout">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<ScheduleOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = merchantPayLaterList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            id="search"
            placeholder="Search transaction # or name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        />
      </div>

      {openDrawer && (
        <MerchantEmployeeCheckoutPayLater
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getAllPayLater={() => rerunPayLater()}
          selectedData={selectedData}
          //   productList={productList}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeOrderPayLater;
